import { useEffect, useRef } from "react";

export function useDebouncedEffect(
  effect: () => void | (() => void),
  deps: React.DependencyList,
  delay = 500
) {
  const cleanupRef = useRef<ReturnType<typeof effect> | void>();

  useEffect(() => {
    const id = setTimeout(() => {
      // si el efecto retorna cleanup, guardarlo
      cleanupRef.current = effect();
    }, delay);

    return () => {
      clearTimeout(id);
      // ejecutar cleanup del efecto previo si existiera
      if (typeof cleanupRef.current === "function") {
        cleanupRef.current();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, delay]);
}
